// Uploads this device put on a record during the session that the server has not yet sent back
// with their audited link: a file it uploaded, a photo or an attachment, or the account's own
// picture copied onto the care recipient or the account's own member. The person looking is the one
// who put it there.
//
// A file uploaded here is shown from the bytes this device still holds rather than from its stored
// url, which is readable only while the uploads bucket is public. The object urls are never revoked,
// because revoking one while a preview or an unsaved note still shows it would blank that preview.
// Each one keeps its file in memory until the page reloads (signing out reloads), which is why an
// uploader that never shows its file can opt out.
export class UploadsAwaitingLinks {
    private localCopies = new Map<string, string | undefined>();

    remember = (params: { url: string; file?: Blob }): void => {
        const { url, file } = params;
        if (this.localCopies.has(url)) {
            return;
        }
        this.localCopies.set(url, file ? URL.createObjectURL(file) : undefined);
    };

    has = (url: string): boolean => this.localCopies.has(url);

    // The local copy when this device uploaded the file, otherwise the stored url unchanged.
    urlFor = (url: string): string => this.localCopies.get(url) ?? url;
}
